import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { FooterLink } from './types/FooterComponentTypes'
import { externalURLS, URLS } from '@/router/routes/urlRoutes'
import useRouter from '@/composables/useRouter'
import { useI18n } from 'vue-i18n-composable'
import { imageURL } from '@/assets/images/url/imageURL'
import LefebvreLogoComponent from '@/components/Logo/LefebvreLogoComponent.vue'

// // COMPOSABLES

export default /*#__PURE__*/_defineComponent({
  __name: 'LefebvreFooterComponent',
  setup(__props) {

const { goToRoute } = useRouter()

// TRANSLATIONS
const { t } = useI18n()

const texts = {
  copyright: t('views.login.copyright_text'),
  lastAccess: t('views.last_access')
}

// // CONSTANTS
const authModule = ModuleNamespaces.AUTH

const footerLinks: FooterLink[] = [
  {
    name: 'views.login.footer.legal_warning',
    url: externalURLS.legal_warning
  },
  {
    name: 'views.login.footer.privacy_policy',
    url: externalURLS.privacy_policy
  },
  {
    name: 'views.login.footer.cookies_policy',
    url: externalURLS.cookies_policy,
    callback: process.env.VUE_APP_COOKIEBOT_ID
      ? (): void => {
          goToRoute({
            name: URLS.COOKIES_POLICY
          })
        }
      : false
  }
]

const socialNetworkLinks: FooterLink[] = [
  {
    name: 'Instagram',
    icon: imageURL.instagram,
    url: externalURLS.instagram
  },
  {
    name: 'Facebook',
    icon: imageURL.facebook,
    url: externalURLS.facebook
  },
  {
    name: 'Linkedin',
    icon: imageURL.linkedin,
    url: externalURLS.linkedin
  },
  {
    name: 'X',
    icon: imageURL.twitter,
    url: externalURLS.twitter
  },
  {
    name: 'Youtube',
    icon: imageURL.youtube,
    url: externalURLS.youtube
  }
]

// // COMPUTED PROPERTIES
const lastAccess = computed(() => store.getters[`${authModule}/getLastAccess`])

const currentYear = computed(() => {
  const year = new Date().getFullYear()
  return year
})

const lastAccessText = computed(() => {
  return `${texts.lastAccess} ${lastAccess.value}`
})

// FUNCTIONS
const handleLinkClick = (event: MouseEvent, link: FooterLink): void => {
  if (link.callback) {
    event.preventDefault()
    link.callback()
  }
}

return { __sfc: true,goToRoute, t, texts, authModule, footerLinks, socialNetworkLinks, lastAccess, currentYear, lastAccessText, handleLinkClick, LefebvreLogoComponent }
}

})